import PropTypes from 'prop-types';
import React from 'react';

import { noop } from 'lodash';

import config from 'trade-in/config/index.js';
import { ContentZonesService, LocaleService } from '@sm360/widget-commons-core-services';
import { AccountService, AdobeService, ADOBE_TAGS, ModalService } from '@sm360/widget-commons-general';

import 'trade-in/components/TradeInTiles/components/TradeInTile/TradeInTile.scss';
import VehicleModelV25 from 'commons-vehicle/Vehicle/models/VehicleModelV25.js';

const TradeInTile = ({ tileContent, onClick, quote, hasAdobeTagging, vehicle }) => {
    const SignUpModal = ModalService.get('login/SignUpModal');
    const SignInModal = ModalService.get('login/SignInModal');
    const OfficialTradeInModal = ModalService.get('trade-in-official-modal');

    const imagesServer = config.source.image;
    const czGroup = 'widget.tradein.teaser';

    const estimateIcon = ContentZonesService.getContentZone(czGroup, 'icon')
        ? ContentZonesService.getContentZone(czGroup, 'icon').getValue()
        : `${imagesServer}/images/widget/showroom/asset/estimate-value-teaser.png`;

    const officialIcon =
        ContentZonesService.getContentZone(czGroup, 'icon.official') &&
        ContentZonesService.getContentZone(czGroup, 'icon.official').getValue();

    const defaultStyleBackgroundColor = '#CD1122';
    const defaultStyleTextColor = '#ffffff';

    const styleBackground = {
        backgroundImage:
            ContentZonesService.getContentZone(czGroup, 'pattern') &&
            `url(${ContentZonesService.getContentZone(czGroup, 'pattern').getValue()})`,
        backgroundColor: ContentZonesService.getContentZone(czGroup, 'primary.background.color')
            ? ContentZonesService.getContentZone(czGroup, 'primary.background.color').getValue()
            : defaultStyleBackgroundColor,
    };
    const estimateTitle = ContentZonesService.getContentZone(czGroup, 'instant.estimate.title')
        ? ContentZonesService.getContentZone(czGroup, 'instant.estimate.title').getValue()
        : LocaleService.t('TRADE_IN.ESTIMATE_TILE.TITLE');

    const estimateSubtitle = ContentZonesService.getContentZone(czGroup, 'instant.estimate.subtitle')
        ? ContentZonesService.getContentZone(czGroup, 'instant.estimate.subtitle').getValue()
        : LocaleService.t('TRADE_IN.ESTIMATE_TILE.SUBTITLE');

    const styleTextColor = {
        color: ContentZonesService.getContentZone(czGroup, 'primary.text.color')
            ? ContentZonesService.getContentZone(czGroup, 'primary.text.color').getValue()
            : defaultStyleTextColor,
    };
    const styleTagLineColor = {
        color: ContentZonesService.getContentZone(czGroup, 'tagline.text.color')
            ? ContentZonesService.getContentZone(czGroup, 'tagline.text.color').getValue()
            : defaultStyleTextColor,
    };

    const loginToOfficialize = () => {
        onClick();
        if (hasAdobeTagging) {
            AdobeService.eventTrigger(
                ADOBE_TAGS.VDP_ACTIONS(
                    quote?.vehicle?.vehicleCondition,
                    'get official value',
                    {
                        make: quote?.vehicle?.make?.name,
                        model: quote?.vehicle?.model?.name,
                    },
                    vehicle?.commercialVehicle
                ),
                'global-onclick'
            );
        }
        if (!AccountService.isAuthenticated()) {
            [SignUpModal, SignInModal].forEach((modal) => {
                modal.addCallbacks({
                    onClose: () => {
                        if (AccountService.isAuthenticated()) {
                            OfficialTradeInModal.open();
                        }
                        return true;
                    },
                });
            });
            SignUpModal.open({ context: 'widget.login.signup.information' });
        } else {
            OfficialTradeInModal.open();
        }
    };
    const blockContent = tileContent ? (
        <div style={styleBackground} className="TradeInTile--content-estimate">
            <div className="TradeInTile--content-estimate-text">
                <img src={estimateIcon} alt="test" />
                <p style={styleTagLineColor} className="sr-text is-small">
                    {LocaleService.t('TRADE_IN.ESTIMATE_TILE.TAGLINE')}
                </p>
                <div className="TradeInTile--content-estimate-title">
                    <p style={styleTextColor} className="sr-subtitle-2 is-centered">
                        {estimateTitle}
                    </p>
                    <p style={styleTextColor} className="sr-text is-small">
                        {estimateSubtitle}
                    </p>
                </div>
            </div>
            <div className="TradeInTile--content-estimate-input">{tileContent}</div>
        </div>
    ) : (
        <div className="TradeInTile--content-official">
            <img src={officialIcon} alt="test" />
            <div className="TradeInTile--content-official-title">
                <p className="sr-subtitle-2 is-centered">{LocaleService.t('TRADE_IN.OFFICIAL_TILE.TITLE')}</p>
                <p className="TradeInTile--content-official-subtitle is-small">
                    {LocaleService.t('TRADE_IN.OFFICIAL_TILE.SUBTITLE')}
                </p>
            </div>
            <button className="sr-button-1 is-small" onClick={loginToOfficialize}>
                {LocaleService.t('TRADE_IN.OFFICIAL_TILE.CTA')}
            </button>
        </div>
    );

    return <div className="TradeInTile--block">{blockContent}</div>;
};

TradeInTile.defaultProps = {
    tileContent: null,
    onClick: noop,
    hasAdobeTagging: false,
    vehicle: new VehicleModelV25(),
};

TradeInTile.propTypes = {
    tileContent: PropTypes.element,
    onClick: PropTypes.func,
    hasAdobeTagging: PropTypes.bool,
    vehicle: PropTypes.instanceOf(VehicleModelV25),
};

TradeInTile.displayName = 'TradeInTile';

export default TradeInTile;
